import { ExtraSmallAnchor, Footer, FooterItem, FooterRow } from '@figure/frontlib-gui';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import EqualHousing from './EqualHousing';

const MainFooter = ({ className, children }) => {
  const { t } = useTranslation();

  return (
    <Footer className={className}>
      <FooterRow>
        <FooterItem>
          <ExtraSmallAnchor href={t('footer.termsURL')} target="_blank" rel="noopener noreferrer" isUnderlined={false}>
            Terms of Service
          </ExtraSmallAnchor>
        </FooterItem>
        <FooterItem>
          <ExtraSmallAnchor href={t('footer.privacyURL')} target="_blank" rel="noopener noreferrer" isUnderlined={false}>
            Privacy Policy
          </ExtraSmallAnchor>
        </FooterItem>
        <FooterItem>
          <ExtraSmallAnchor href={t('footer.licensesURL')} target="_blank" rel="noopener noreferrer" isUnderlined={false}>
            Licenses
          </ExtraSmallAnchor>
        </FooterItem>
      </FooterRow>

      <>
        <FooterRow>
          <FooterItem>© {t('footer.companyName')}</FooterItem>
        </FooterRow>

        <FooterRow>
          <FooterItem>{t('footer.companyProduct')}</FooterItem>
          <FooterItem>
            <ExtraSmallAnchor href={t('footer.companyNmlsURL')} target="_blank" rel="noopener noreferrer" isUnderlined={false}>
              {t('footer.companyNMLS')}
            </ExtraSmallAnchor>
          </FooterItem>
        </FooterRow>
      </>

      {children}

      <EqualHousing>Equal Housing Opportunity</EqualHousing>
    </Footer>
  );
};

MainFooter.propTypes = {
  className: PropTypes.string,
  children: PropTypes.array,
};

MainFooter.defaultProps = {
  className: '',
  children: [],
};

export default MainFooter;
